@if (filterForm) {
    <mat-drawer-container [hasBackdrop]="true">
        <mat-drawer #sidenav [mode]="'over'">
            <app-issue-list-filter-sidebar
                [filterForm]="filterForm"
                (closeButtonClicked)="sidenav.close()"
                [statusList]="statusList"
                [monitoringMethodList]="monitoringMethodList"
                [timeFrameList]="timeFrameList"
                [timeFrameTitle]="'Time Frame (UTC)'"
                [eventClassificationsList]="eventClassifications$ | async"
                [showGroupFilters]="true"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-issue-list-filter-sidebar>
        </mat-drawer>
        <mat-drawer-content class="app-content listings">
            <app-issue-list-filter-topbar
                [filterForm]="filterForm"
                [currentFilters]="currentFilters"
                (filterButtonClicked)="sidenav.open()"
                [statusList]="statusList"
                [timeFrameList]="timeFrameList"
                [monitoringMethodList]="monitoringMethodList"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-issue-list-filter-topbar>

            <div class="app-content px-0">
            @if (stats$ | async; as stats) {
                <app-assurance-type-stats [data]="stats.data"></app-assurance-type-stats>
            } @else {
                <app-loading-indicator></app-loading-indicator>
            }
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
}
